import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify"; // For Toastify
import "react-toastify/dist/ReactToastify.css";

const SsoLogin = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  // Check if SSO is allowed based on the 'TEMPORARY_NAME' check
  const checkEligibility = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/sso-login/check`,
        { email }
      );
      return response.data.eligible;
    } catch (error) {
      toast.error(error.response?.data?.message || "Eligibility check failed");
      return false;
    }
  };

  // Handle SSO login submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isEligible = await checkEligibility();
    if (!isEligible) return; // Stop if not eligible for SSO

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/sso-login`,
        { email, otp }
      );
      localStorage.setItem("token", response.data.token); // Store token
      toast.success(response.data.message);
      setTimeout(() => navigate("/complete-profile"), 3000); // Navigate after 3s
    } catch (error) {
      toast.error("Invalid OTP or login failed");
    }
  };

  // Handle email input and convert to lowercase
  const handleEmailChange = (e) => {
    setEmail(e.target.value.toLowerCase());
  };

  return (
    <div className="Top">
      <div className="CardContainer">
<form onSubmit={handleSubmit}>
        <div className="CardContainerTitle">
          <h2>SSO Login</h2>
        </div>
        
          <label>
            Email:
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={handleEmailChange} // Use the new handler
              required
            />
          </label>
          <label>
            SSO Token:
            <input
              className="form-input"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </label>
          <button className="btn-gl" type="submit">
            Login
          </button>
        </form>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
        />
      </div>
    </div>
  );
};

export default SsoLogin;
